/**
 * `/app/widgets/$widgetRef/submissions` — a forms widget's inbox. The page is
 * `pages/forms/SubmissionsPage.tsx`; this file is the address.
 *
 * `?tab=`, `?form=` and `?q=` are the page's own, declared here so the router keeps them
 * across a navigation and types them for a `Link` — the forms list's "See its leads"
 * hands over `form`. Through `routeSearch`, so a value somebody typed falls back to the
 * open inbox rather than to an error page.
 */

import { createFileRoute } from '@tanstack/react-router'

import { NotFound } from '../../../../../errors/NotFound.js'
import { SubmissionsPage } from '../../../../../pages/forms/SubmissionsPage.js'
import { parseSubmissionsSearch } from '../../../../../pages/forms/search.js'

export const Route = createFileRoute('/app/widgets/$widgetRef/submissions/')({
  validateSearch: parseSubmissionsSearch,
  notFoundComponent: NotFound,
  component: SubmissionsRoute,
})

function SubmissionsRoute() {
  const { widgetRef } = Route.useParams()
  return <SubmissionsPage widgetRef={widgetRef} />
}
